// extracted by mini-css-extract-plugin
export default {"closeDaysContainer":"CloseDays_closeDaysContainer__O5Lg2"};